export const SATHI_BULK_ACTION_COMPLETED_NOTIFICATION_TYPES = {
  COMMISSION_TIERS_UPDATED: 'bulk_commission_tiers_updated',
  DISCOUNT_CODES_UPDATED: 'bulk_discount_codes_updated',
  DISCOUNT_CODES_CREATED: 'bulk_discount_codes_created',
  SHIP_FREE_PRODUCT_COMPLETED: 'bulk_ship_free_product_completed',
} as const;

export type SathiBulkActionCompletedNotificationType =
  (typeof SATHI_BULK_ACTION_COMPLETED_NOTIFICATION_TYPES)[keyof typeof SATHI_BULK_ACTION_COMPLETED_NOTIFICATION_TYPES];

export const SATHI_BULK_ACTION_COMPLETED_NOTIFICATION_TYPE_VALUES = Object.values(
  SATHI_BULK_ACTION_COMPLETED_NOTIFICATION_TYPES
);
